<script>
  import Input from '@ui/pico/input.svelte';
  import { editSiteSvc, getSite } from '../../services';
  import { goto } from '../../util';
  import { handleRedirect, pages } from '../../config';
  import { account } from '../../store';

  export let params;
  let site;

  $: sid = params?.sid;
  $: editSite = {
    sid,
    domain: '',
    description: '',
  };

  $: {
    if ($account && !site) {
      init();
    }
  }

  async function init() {
    site = await getSite({ sid });

    editSite.domain = site?.domain;
    editSite.description = site?.description;
  }

  function onCancel() {
    if (!handleRedirect(params.from, { sid }, goto)) {
      goto(pages.account.url);
    }
  }
  async function onConfirm() {
    await editSiteSvc(editSite);
    if (!handleRedirect(params.from, { sid }, goto)) {
      goto(pages.sites.overview.url, sid);
    }
  }
</script>

<form on:submit|preventDefault={onConfirm}>
  <dialog open>
    <article>
      <h3>Edit Site</h3>
      <Input
        type="text"
        bind:value={editSite.domain}
        name="domain"
        label="Domain Name"
      />
      <Input
        type="text"
        bind:value={editSite.description}
        name="description"
        label="Description"
      />
      <footer>
        <button type="button" class="secondary" on:click={onCancel}>
          Cancel
        </button>
        <button type="submit">Update</button>
      </footer>
    </article>
  </dialog>
</form>

<style>
  article {
    width: 60vw;
    max-width: 900px;
  }
</style>
